import apiRequest from '@/js/helpers/apiRequest';
import { buildErrorCollection } from '@/js/utils/processingOpenApi';
import { ERROR_CAPTCHA } from '@/js/utils/constants/constUser';

/**
 * Новый эндпоинт - Отправка введенного пользователем проверочного кода
 * @param {Object} payload
 * @param {string} [payload.phone]
 * @param {string} [payload.confirmCode]
 * @param {string} [payload.captchaToken]
 * @param {string} [payload.captchaAction]
 * @param {('rv2' | 'rv3')} [payload.captchaVersion]
 * @return {Promise<void>}
 */
export default function sendReceivedCodeNew(payload = {}) {
  return new Promise((resolve, reject) => {
    if (!payload.captchaToken) {
      return reject(ERROR_CAPTCHA.emptyCaptchaToken);
    }
    if (typeof payload.captchaToken !== 'string') {
      return reject(ERROR_CAPTCHA.notStringCaptchaToken);
    }
    if (!payload.captchaAction) {
      return reject(ERROR_CAPTCHA.emptyCaptchaAction);
    }
    if (typeof payload.captchaAction !== 'string') {
      return reject(ERROR_CAPTCHA.notStringCaptchaAction);
    }
    if (!payload.captchaVersion) {
      return reject(ERROR_CAPTCHA.emptyCaptchaVersion);
    }
    if (typeof payload.captchaVersion !== 'string') {
      return reject(ERROR_CAPTCHA.notStringCaptchaVersion);
    }
    apiRequest.post(`/phones-confirm-verification/?code=${payload.confirmCode}`, payload)
      .then((dataRes) => {
        if (dataRes.success) {
          return resolve(true);
        }

        throw new Error();
      })
      .catch((e) => {
        if (e.data) {
          const errors = buildErrorCollection(e.data);
          const [firstError] = errors;
          return reject(firstError);
        }
        return reject(e);
      });
  });
}
